import React, { Component } from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';

class SaveFileDialog extends Component {
    constructor() {
        super();

        this.state = {
            filename: ''
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleInput(event, newValue) {
        this.setState({
            filename: newValue
        });
    }

    handleClose() {
        this.props.onClose(this.state.filename, true);
    }

    handleSave() {
        this.props.onClose(this.state.filename, false);
    }

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={this.handleClose}
            />,
            <FlatButton
                label="Save"
                primary={true}
                keyboardFocused={true}
                onClick={this.handleSave}
            />,
        ];

        return (
            <Dialog
                title="Save File"
                actions={actions}
                modal={false}
                open={this.props.open}
                onRequestClose={this.props.handleClose}
            >
                <TextField hintText="Enter filename" onChange={this.handleInput} />
            </Dialog>
        );
    }
}

export default SaveFileDialog;


// WEBPACK FOOTER //
// ./src/components/document-editor/save_file_dialog.jsx